// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"614":"34ba1c1e","701":"638d9237","912":"40d53563"}[chunkId] + ".chunk.js";
};